<template>
  <div class="md-layout marginTimeline">
    <!-- <div class="swiper-container">
      <div class="swiper-wrapper timeline">
        <div :key="item.title" class="swiper-slide" v-for="item in timeline">
          <div class="timestamp">
            <img class="date" :src="item.flag" />
          </div>
          <div class="status">
            <span>{{item.year}}</span>
          </div>
        </div>
      </div>
    </div>-->
    <div class="md-layout-item md-size-40"></div>
    <div class="md-layout-item md-layout md-size-60 frise">
      <div
        :key="item.title"
        v-for="item in timeline"
        class="md-layout-item md-size-20 contentTimeline"
        @click="onTimelineClicked(item)"
      >
        <img :src="item.flag" class="flagTimeline" />
        <div class="dateTimeline">{{item.year}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// @ is an alias to /src
import Swiper from "swiper";

export default {
  name: "me",
  props: ["timeline"],
  components: {},
  data() {
    return {};
  },
  mounted() {
    // eslint-disable-next-line
    var swiper = new Swiper(".swiper-container", {
      //pagination: '.swiper-pagination',
      slidesPerView: 4,
      grabCursor: true,
      paginationClickable: true,
      nextButton: ".next-slide",
      prevButton: ".prev-slide"
    });
  },
  computed: {
    ...mapGetters(["getMyDataContent", "getStructure"])
  },
  methods: {
    ...mapActions(["setCurrentCountry", "setCurrentContinent"]),
    onTimelineClicked(item) {
      const conti = this.getStructure.find(
        ({ code }) => code === item.continent
      );
      this.setCurrentContinent(conti);
      const c = conti.countries.find(({ country }) => country === item.country);
      this.setCurrentCountry(c);
      this.$router.push("/map/articles");
    }
  }
};
</script>

<style >
.flagTimeline {
  margin-top: -70px;
}

.dateTimeline {
  margin-top: 15px;
  margin-left: 15px;
  color: #046380;
  font-weight: bold;
  font-size: 20px;
}

.contentTimeline {
  margin-left: 20px;
  margin-right: 20px;
}

.marginTimeline {
  margin-top: 80px;
  margin-left: 80px;
  margin-bottom: 80px;
}

.frise {
  margin-top: 100px;
  margin-bottom: 30px;
  height: 30px;
  background-color: #046380;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  width: 50vw;
}
.home {
}

.fullHeight {
  height: 88vh;
}
.mePic {
}
.textWrap {
  max-height: 150px;
  float: left;
  margin-right: 15px;
  margin-bottom: 15px;
}

.meText {
  font-size: 25px;
  text-align: justify;
  line-height: 35px;
  margin: 0;
}

.paddin {
  padding-left: 50px;
  padding-right: 50px;
}

.icons {
  width: 100px;
  border-radius: 20px;
  margin: 20px;
}

.icons:hover {
  cursor: pointer;
}

.timeline {
  margin: 50px 0;
  list-style-type: none;
  display: flex;
  padding: 0;
  text-align: center;
}
.timeline li {
  transition: all 200ms ease-in;
}
.timestamp {
  margin-bottom: 20px;
  padding: 0px 40px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 100;
}
.status {
  padding: 0px 40px;
  display: flex;
  justify-content: center;
  border-top: 4px solid #3e70ff;
  position: relative;
  transition: all 200ms ease-in;
}

.status span {
  font-weight: 600;
  padding-top: 20px;
  margin-right: 20px;
}
.status span:before {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #e8eeff;
  border-radius: 25px;
  border: 4px solid #3e70ff;
  position: absolute;
  top: -15px;
  left: 42%;
  transition: all 200ms ease-in;
}
.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  height: 250px;
  margin: 50px 0;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.swiper-slide {
  width: 200px;
  text-align: center;
  font-size: 18px;
}
.swiper-slide:nth-child(2n) {
  width: 40%;
}
.swiper-slide:nth-child(3n) {
  width: 20%;
}
</style>
